import React from 'react';
import { Link } from '../packages/Link';

export const content = [
  {
    title: 'Можно ли отредактировать заявку?',
    text: 'Отправленную заявку отредактировать нельзя. Вместо этого вы можете подать новую заявку.',
  },
  {
    title: 'Сколько ждать звонка?',
    text: 'Заявка остается активной в течение 7 дней. Обычно звонки начинают поступать в первые часы после публикации. Если с вами не связались, попробуйте отправить новую заявку, указав более подробную информацию, чтобы повысить интерес со стороны риелторов.',
  },
  {
    title: 'Кому отправляется заявка?',
    text: 'Заявка становится доступна всем риелторам-партнерам Циан в регионе, по которому она создана. Ее может взять в работу как агенство недвижимости, так и частный риелтор, который работает в данном регионе и сегменте недвижимости.',
  },
  {
    title: 'Какая информация доступна риелтору?',
    text: 'Риелтору доступны все данные, которые вы указывали при заполнении заявки.',
  },
  {
    title: 'Сколько стоит подбор?',
    text: 'Мы подбираем риелтора бесплатно. Условия работы с конкретным риелтором вы сможете обсудить напрямую.',
  },
  {
    title: 'Я уже разместил объявление. Надо ли оставлять заявку?',
    text: 'Заявка и объявление не зависят друг от друга. Отправьте заявку, чтобы быстрее получить помощь риелтора.',
  },
  {
    title: 'Сколько риелторов получит заявку?',
    text: 'Мы предоставляем контакты по вашей заявке максимум 3 риелторам. Если у вас есть опубликованное объявление с теми же контактами, звонки могут поступать по нему.',
  },
  {
    title: 'Можно ли отменить заявку?',
    text: (
      <>
        Да. Для этого напишите нам через{' '}
        <Link href="https://www.cian.ru/contacts/" target="_blank">
          форму обратной связи
        </Link>
        , указав номер телефона, который вы использовали при подаче заявки на подбор.
      </>
    ),
  },
];
